namespace nscs.util {

    export class Functions {

        private static SCALE_UP_TEXT_FIELDS:number = 3;

        public static rewriteWordWrapping():void {
            (function(setWordWrapWidth) {// Cache the original method
                Phaser.GameObjects.Text.prototype.setWordWrapWidth = function(t, e) {// Redefine the method
                    if (!this.hasOwnProperty('-wordWrapWidth-')) {
                        this['-wordWrapWidth-'] = t;
                    }
                    if (typeof e === "undefined") e = true;
                    // Now, call the original method
                    return setWordWrapWidth.apply(this, [t, e]);
                };
            })(Phaser.GameObjects.Text.prototype.setWordWrapWidth);
        }

        public static updateTextFieldPosition(textField:Phaser.GameObjects.Text, setText:string = null):void {
            if (!textField.hasOwnProperty('-fontSize-')) {
                let fontSize:number = Number(textField.style.fontSize.split('px')[0]);
                textField["-fontSize-"] = fontSize;
                textField.setFontSize(fontSize * Functions.SCALE_UP_TEXT_FIELDS);
                textField.setScale(1 / Functions.SCALE_UP_TEXT_FIELDS);
                if (textField['-wordWrapWidth-']) {
                    textField.setWordWrapWidth(textField['-wordWrapWidth-'] * Functions.SCALE_UP_TEXT_FIELDS);
                }
            }
            if (!textField.hasOwnProperty('-strokeThickness-')) {
                if (textField.style.stroke) {
                    textField["-strokeThickness-"] = textField.style.strokeThickness;
                    textField.setStroke(textField.style.stroke, textField.style.strokeThickness * Functions.SCALE_UP_TEXT_FIELDS);
                }
            }
            if (!textField.hasOwnProperty('-originX-')) {
                textField["-originX-"] = textField.originX;
                textField.originX = 0;
            }
            if (!textField.hasOwnProperty('-originY-')) {
                textField["-originY-"] = textField.originY;
                textField.originY = 0;
            }
            if (!textField.hasOwnProperty('-def-x-')) {
                textField['-def-x-'] = textField.x;
            }
            if (!textField.hasOwnProperty('-def-y-')) {
                textField['-def-y-'] = textField.y;
            }
            if (setText) {
                textField.setText(setText);
            }
            textField.x = Math.round(textField['-def-x-'] - textField.width*textField.scaleX*textField["-originX-"]);
            textField.y = Math.round(textField['-def-y-'] - textField.height*textField.scaleY*textField["-originY-"]);
        }

        private static delayedCalls = [];
        public static delayedCall(delay: number, callback: Function, args?: any[], callbackScope?: any): Phaser.Time.TimerEvent | number {
            let scene = game.scene.getAt(0);
            if (scene) {
                let dc = scene.time.delayedCall(delay, callback, args, callbackScope);
                Functions.delayedCalls.push(dc);
                return dc;
            }
            let t = setTimeout(callback, delay);
            Functions.delayedCalls.push(t);
            return t;
        }
        public static pauseAllDelayedCalls() {
            for (let dc of Functions.delayedCalls) {
                if (dc instanceof Phaser.Time.TimerEvent) {
                    (dc as Phaser.Time.TimerEvent).paused = true;
                }
            }
        }
        public static resumeAllDelayedCalls() {
            for (let dc of Functions.delayedCalls) {
                if (dc instanceof Phaser.Time.TimerEvent) {
                    (dc as Phaser.Time.TimerEvent).paused = false;
                }
            }
        }
        public static destroyAllDelayedCalls() {
            for (let dc of Functions.delayedCalls) {
                if (dc instanceof Phaser.Time.TimerEvent) {
                    (dc as Phaser.Time.TimerEvent).remove(false);
                } else {
                    clearTimeout(dc);
                }
            }
            Functions.delayedCalls = [];
        }
        public static destroyDelayedCall(dc) {
            let ind:number = Functions.delayedCalls.indexOf(dc);
            if (ind >= 0) {
                Functions.delayedCalls.splice(ind, 1);
            }
            if (dc instanceof Phaser.Time.TimerEvent) {
                (dc as Phaser.Time.TimerEvent).remove(false);
            } else {
                clearTimeout(dc);
            }
        }

        public static capitalise(str:string) {
            let newstr:string = '';
            let words = str.split(' ');
            for (let w=0; w<words.length; w++) {
                let word:string = words[w];
                word = word.substr(0, 1).toUpperCase()+word.substr(1);
                newstr += (newstr) ? ' ' : '';
                newstr += word;
            }
            return newstr;
        }

        public static trim(str:string) {
            let newline:string = '\n';
            while (str.substr(0, 1) == ' ') {
                str = str.substr(1);
            }
            while (str.substr(0, 1) == newline) {
                str = str.substr(1);
            }
            while (str.substr(0, 1) == '    ') {
                str = str.substr(0, -1);
            }
            while (str.substr(-1, 1) == ' ') {
                str = str.substr(0, -1);
            }
            while (str.substr(-1, 1) == newline) {
                str = str.substr(0, -1);
            }
            while (str.substr(-1, 1) == '    ') {
                str = str.substr(0, -1);
            }
            return str;
        }



        public static DetectPhaserRenderMode() {
            // var ua = window.navigator.userAgent;
            // var isIE = ua.indexOf('MSIE ') > 0 || ua.indexOf('Trident/') > 0;
            // var isOldIPhone = (ua.indexOf('iPhone ') > -1 && window.screen.width <= 414 && window.screen.height <= 736);
            // var isFirefox = ua.toLowerCase().indexOf('firefox') > -1;
            // var isAndroid = ua.toLowerCase().indexOf("android") > -1;
            // if (isIE) return Phaser.CANVAS;
            // if (isFirefox) return Phaser.WEBGL;
            return Phaser.AUTO;
        };

        public static pad(n, width, z) {
            z = z || '0';
            n = n + '';
            return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
        };
    }
}
